import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Reimbursement() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Política de Reembolso</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Inicio
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">Política de Reembolso</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Derecho al reembolso
              </h2>
              <p className="text-base leading-relaxed">
                En TVDIAMO, nos comprometemos a garantizar su satisfacción.
                Es por eso que ofrecemos una política de reembolso de 15
                días para todos nuestros usuarios. Si, por cualquier
                razón, no está satisfecho con nuestros servicios, puede
                solicitar un reembolso dentro de los 15 días posteriores a su
                compra.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Condiciones de reembolso
              </h2>
              <p className="text-base leading-relaxed">
                Para ser elegible para un reembolso, se deben cumplir las siguientes
                condiciones:
              </p>
              <ul className="list-disc list-inside pt-2">
                <li>
                  La solicitud debe realizarse dentro de los 15 días posteriores a la
                  fecha de compra.
                </li>
                <li>
                  Debe proporcionar una prueba de compra válida, como su recibo
                  o correo electrónico de confirmación.
                </li>
                <li>
                  Los reembolsos no están disponibles si ya ha
                  utilizado más del 50% de su período de suscripción.
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Proceso de solicitud
              </h2>
              <p className="text-base leading-relaxed">
                Para solicitar un reembolso, siga estos pasos:
              </p>
              <ol className="list-inside list-decimal pt-2">
                <li>
                  Contacte a nuestro equipo de soporte vía WhatsApp o correo electrónico.
                </li>
                <li>
                  Proporcione su número de pedido y el motivo del
                  reembolso.
                </li>
                <li>
                  Adjunte la prueba de compra (recibo o correo electrónico de confirmación).
                </li>
              </ol>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Método de reembolso
              </h2>
              <p className="text-base leading-relaxed">
                Si su solicitud de reembolso es aprobada, el monto será
                reembolsado a través del mismo método de pago que utilizó
                para su compra. El tiempo de procesamiento puede variar según su
                proveedor de pago.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Contáctenos</h2>
              <p className="text-base leading-relaxed mb-4">
                Para cualquier pregunta sobre esta política de reembolso o para
                ejercer sus derechos, puede contactarnos a través de:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Haga clic aquí para contactarnos
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Gracias por elegir {contactInfo.companyName}. Estamos orgullosos de garantizar
                su privacidad y ofrecerle un servicio de alta
                calidad sin comprometer su seguridad o su anonimato.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
